import * as React from "react";
function SignOutIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.19 66.83 20 20a4.002 4.002 0 1 0 5.66-5.66L13.67 68H88a4 4 0 0 0 0-8H13.67l13.18-13.17a4.002 4.002 0 1 0-5.66-5.66l-20 20q-.275.28-.5.6s0 .11-.08.16a3 3 0 0 0-.28.53 2 2 0 0 0-.08.24 3 3 0 0 0-.15.51 3.9 3.9 0 0 0 0 1.58q.054.261.15.51.033.122.08.24.115.274.28.52c0 .06.05.11.08.16q.225.325.5.61m31.13 35c20.876 19.722 53.787 18.787 73.509-2.089 14.874-15.743 18.432-39.058 8.931-58.521-10.77-22.12-42-37.41-69.52-24a52 52 0 0 0-12.91 8.93 4.004 4.004 0 0 1-5.49-5.83 60 60 0 0 1 14.9-10.29C67.26-2.37 106.48 6 122 37.74c14.519 29.787 2.142 65.704-27.645 80.223-22.44 10.938-49.308 6.839-67.465-10.293a4 4 0 0 1 5.48-5.82z"
  }));
}
export default SignOutIcon;